/** @file Chain picker shared by IK create and edit: the end bone and a chain length of 1 or 2. */
import type { Translate } from '@pose2d/i18n/types';
import { Select, type SelectOption } from '../../ui-kit/Select';

/** Props of IkChain; `bones` are the bone options (generated socket bones left out). */
export interface IkChainProps {
  t: Translate;
  bones: readonly SelectOption[];
  end: string;
  length: 1 | 2;
  onChange: (end: string, length: 1 | 2) => void;
}

/** Two selects; the caller turns them into bones with ikChainBones. */
export function IkChain({ t, bones, end, length, onChange }: IkChainProps) {
  const lengths = [{ value: '1', label: t('panels.constraints.oneBone') }, { value: '2', label: t('panels.constraints.twoBones') }];
  return (
    <div className="rig-row">
      <Select label={t('panels.constraints.endBone')} value={end} options={bones} onChange={(next) => { onChange(next, length); }} />
      <Select label={t('panels.constraints.chain')} value={String(length)} options={lengths} onChange={(next) => { onChange(end, next === '1' ? 1 : 2); }} />
    </div>
  );
}
